import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { BehaviorSubject, Observable, interval } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-count-down',
  templateUrl: './count-down.component.html',
  styleUrls: ['./count-down.component.css']
})
export class CountDownComponent implements OnInit {

  @Input()
  startDate : Date = new Date();
  @Input()
  endDate : Date;

  endDate$: Observable<Date>;

  @Input()
  textAdd : string;

  @Input()
  styleClass : string;

  @Output()
  onCloseEvent: EventEmitter<boolean> = new EventEmitter();

  loading: boolean = true;
  constructor(public config: DynamicDialogConfig, public ref: DynamicDialogRef
    ) { }

  ngOnInit(): void {
    this.buildDates();
    this.start();
    this.loading = false;
  }

  buildDates(){
    if(this.config?.data?.startDate){
      this.startDate = new Date(this.config.data.startDate);
      this.endDate = this.config.data.endDate ?? new Date();
      this.styleClass = this.config.data.styleClass
      this.textAdd = this.config.data.textAdd;
      return;
    }
    this.endDate = this.endDate ?? new Date();

  }

  onClose(acceptOrClose? : boolean){
    if(this.config && this.ref){
      this.ref.close(acceptOrClose);
    }else{
      this.onCloseEvent.emit(acceptOrClose);
    }

  }


  start() {
    this.endDate$ = interval(1000).pipe(
      map(() => {
        this.startDate.setSeconds(this.startDate.getSeconds() + 1);       
        return this.endDate; 
      })
    );
  }
}
